// extracted by mini-css-extract-plugin
export default {"noProjectsWrapper":"ProjectsListNoProjects_noProjectsWrapper__Fn6B9"};